export const intNumberWithSpaces = (num: number): string => {
  if ((num && typeof num === "number") || num === 0) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  } else {
    return "";
  }
};

export const numberWithSpaces = (num: number): string => {
  if ((num && typeof num === "number") || num === 0) {
    const newValue = num.toFixed(2);
    const parts = newValue.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  } else {
    return "";
  }
};
